import React from 'react';
import { FOOTER_LINKS, FOOTER_CONTENT, LEGAL } from '../constants';
import { useLanguage } from '../LanguageContext';

export default function SiteFooter() {
  const { lang }   = useLanguage();
  const links      = FOOTER_LINKS[lang];
  const content    = FOOTER_CONTENT[lang];

  const scrollTo = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="pb-footer" id="legal" data-testid="pb-footer">
      <div className="pb-container">
        <div className="pb-footer-grid">
          {/* Brand */}
          <div>
            <div className="pb-footer-brand">
              <div className="pb-footer-brand-mark">
                <svg width="20" height="20" viewBox="0 0 28 28" fill="none" aria-hidden="true">
                  <rect width="28" height="28" rx="6" fill="white" fillOpacity="0.15"/>
                  <rect x="7" y="7" width="3" height="14" fill="white" rx="1"/>
                  <path d="M10 7h6a4 4 0 0 1 0 8h-6z" fill="white"/>
                  <rect x="7" y="19" width="10" height="2" rx="1" fill="#0055A4"/>
                </svg>
              </div>
              <span className="pb-footer-brand-name">PitBoard<span>.</span></span>
            </div>
            <p className="pb-footer-desc">{content.desc}</p>
            <a
              href="mailto:cockpit@pitboardsuite.com"
              style={{ display: 'inline-block', marginTop: 16, fontSize: 13, color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}
              data-testid="pb-footer-email"
            >
              {LEGAL.email}
            </a>
          </div>

          {/* Produit */}
          <div>
            <div className="pb-footer-col-title">{content.colProduct}</div>
            <ul className="pb-footer-links">
              {links.produit.map(l => (
                <li key={l.label}>
                  <a href={l.href} onClick={e => scrollTo(e, l.href)}>{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Entreprise */}
          <div>
            <div className="pb-footer-col-title">{content.colCompany}</div>
            <ul className="pb-footer-links">
              {links.entreprise.map(l => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    onClick={e => l.href.startsWith('#') ? scrollTo(e, l.href) : null}
                    target={l.href.startsWith('/') ? '_self' : undefined}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Sites */}
          <div>
            <div className="pb-footer-col-title">{content.colSites}</div>
            <ul className="pb-footer-links">
              <li><a href="https://pitboardsuite.com" style={{ color: 'rgba(255,255,255,0.65)' }}>pitboardsuite.com</a></li>
              <li><a href="https://pitboardsuite.fr" style={{ color: 'rgba(255,255,255,0.65)' }}>pitboardsuite.fr</a></li>
            </ul>
          </div>
        </div>

        <div className="pb-footer-bottom">
          <div className="pb-footer-copy">
            © {new Date().getFullYear()} PitBoard Suite — {content.copy}
          </div>
        </div>
      </div>
    </footer>
  );
}
